import { Components, Theme } from '@mui/material';

export const MuiDialog: Components<Omit<Theme, 'components'>>['MuiDialog'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '& .MuiDialogActions-root.MuiDialogActions-spacing': {
        padding: '0 25px 20px 0',
      },
      '& .MuiDialog-paper': {
        backgroundColor: theme.palette.surfaceContainer.container,
        '--Paper-overlay': 'none !important',
      },
    }),
  },
};
